export default __webpack_public_path__ + "static/1-5fcb0a056b486c179399b6ae797d50ef.png";